import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { DocumentsCard, MobileCard } from './style';
import { downloadResource } from '../../../../utils/fileDownload';
import { FileImg } from '../../../../app/pages/DocumentDetails/style';
import { getIconByExtension } from '../../../../utils/fileExtension';
import { formatFileSize } from '../../../../utils/formatFileSize';
import Text from '../../Text';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';
import CTA from '../../CTA';
import { getUrlWithToken, timestampToDate } from '../../../../utils/common';

const CardDocuments = ({
  mediaIsPhone,
  mediaIsTablet,
  item,
  onClick,
  className,
}) => {
  const [file, setFile] = useState();

  useEffect(() => {
    if (item?.file_info) setFile(item.file_info);
    if (item?.file) setFile(item.file);
  }, [item]);

  if (mediaIsPhone || mediaIsTablet) {
    return (
      <MobileCard className={className}>
        <h5>Nome</h5>
        <Text type="h3" onClick={onClick} className="title">
          {item?.title}
        </Text>
        <h5>Formato</h5>
        <div className="file-icon">
          <FileImg src={getIconByExtension(file?.extension)} />
        </div>
        <h5>Tipologia</h5>
        <Text type="b4" className="ellipsis">
          {!(item?.document_typology?.length > 0) && '-'}
          {(item?.document_typology || []).map((t, i) => (
            <span key={`typology-${i}`}>
              {i > 0 && <span> - </span>}
              {t?.name}
            </span>
          ))}
        </Text>
        <h5>Data</h5>
        <Text type="b5" className="date" color="#515151">
          {timestampToDate(item?.last_saved || item?.created)}
        </Text>
        <h5>Dimensione</h5>
        <Text type="b5" className="size" color="#8B8B8B">
          {formatFileSize(file?.size)}
        </Text>
        <div />
        <CTA
          btnText="Download"
          icon="download-01"
          type="tertiary"
          onClick={() =>
            downloadResource(getUrlWithToken(file?.url), file?.filename)
          }
        />
      </MobileCard>
    );
  }

  return (
    <DocumentsCard className={className}>
      <div className="file-icon">
        <FileImg src={getIconByExtension(file?.extension)} />
      </div>
      <Text type="h3" onClick={onClick} className="title">
        {item?.title}
      </Text>
      <Text type="b4" className="ellipsis">
        {!(item?.document_typology?.length > 0) && '-'}
        {(item?.document_typology || []).map((t, i) => (
          <span key={`typology-${i}`}>
            {i > 0 && <span> - </span>}
            {t?.name}
          </span>
        ))}
      </Text>
      <Text type="b5" className="date" color="#515151">
        {timestampToDate(item?.last_saved || item?.created)}
      </Text>
      <Text type="b5" className="size" color="#8B8B8B">
        {formatFileSize(file?.size)}
      </Text>
      <div>
        <CTA
          btnText="Download"
          icon="download-01"
          type="tertiary"
          onClick={() =>
            downloadResource(getUrlWithToken(file?.url), file?.filename)
          }
        />
      </div>
    </DocumentsCard>
  );
};

CardDocuments.propTypes = {
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  item: PropTypes.object,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default withMediaQueries(CardDocuments);
